import React from 'react';
import TopBar from './TopBar';
import MainNav from './MainNav';
import OnlinePaymentWidget from './OnlinePaymentWidget';
import AvisSection from './AvisSection';
import { useAuth } from '../context/AuthContext';
import { stopImpersonation } from '../api/auth';
import './Layout.css';

const Layout = ({ children, showExtras = false, showAvis = false }) => {
  const withAvis = showExtras || showAvis;
  const { company } = useAuth();
  // Le widget de paiement mene a la facturation : cache si cette page est
  // retiree (utilisateur de company / staff limite, cf. company.menu_keys).
  const canSeeBilling =
    !Array.isArray(company?.menu_keys) || company.menu_keys.includes('/parametres/facturation');

  const handleQuit = async () => {
    try { await stopImpersonation(); } catch (err) { /* on sort quand meme */ }
    window.location.assign('/superadmin/companies');
  };

  return (
    <div className="layout-root">
      {company?.impersonated && (
        <div className="impersonation-banner">
          <span>
            ⚠ Mode superadmin — vous naviguez dans <strong>{company.name}</strong> avec les droits complets.
          </span>
          <button type="button" className="impersonation-quit" onClick={handleQuit}>
            Quitter
          </button>
        </div>
      )}
      <TopBar />
      <MainNav />
      <div className={`layout-body${showExtras ? ' layout-body-narrow' : ''}`}>
        {children}
        {withAvis && <AvisSection />}
      </div>
      {showExtras && canSeeBilling && <OnlinePaymentWidget />}
    </div>
  );
};

export default Layout;
